/**
 * WEB-3447, заход 3 — одна дверь единого ленивого куска плеера
 * (`playerKit.ts`). Приём — общая дверь `lazyModuleDoor.ts`: наборы зовут
 * `playerKitDoor.get()` СИНХРОННО и без куска отдают запасной ответ «как
 * будто поля нет»; кабинет кладёт кусок статически (`main.tsx`), тестовая
 * обвязка — синхронным добытчиком (`jest.setup.ts`).
 */
import { createLazyModuleDoor } from './lazyModuleDoor';
import { retryImport } from '@/utils/lazyWithRetry';
import type { QuizChromeKit } from '@/components/quiz-runtime/quizChromeKitDoor';
import type { StyleKit } from '@/themes/styleKit';

export type ComputedValuesModule = typeof import('./computedValues');
/** WEB-2351, возврат 1: проверка границ числа автора. */
export type NumberBoundsModule =
  typeof import('@/components/quiz-runtime/numberBounds');

export interface PlayerKit {
  computedValues: ComputedValuesModule;
  chrome: QuizChromeKit;
  style: StyleKit;
  numberBounds: NumberBoundsModule;
}

/**
 * Заказ файла куска — объектом, чтобы тест страницы мог придержать его
 * (`jest.spyOn`), как `STYLE_PACK_IMPORTERS` у паков. Ключ защёлки
 * перезагрузки — литерал `chunk:player-kit` (свой у этого файла, с ключами
 * кусков рендерера не совпадает — сторож `lazyWithRetry.callKeys.guard`).
 */
export const PLAYER_KIT_IMPORTER = {
  load: (): Promise<PlayerKit> =>
    retryImport(
      () =>
        import('./playerKit').then((module) => ({
          default: module.PLAYER_KIT,
        })),
      'chunk:player-kit',
    ).then((module) => module.default),
};

export const playerKitDoor = createLazyModuleDoor<PlayerKit>(() =>
  PLAYER_KIT_IMPORTER.load(),
);
